import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  IChangeActivity,
  IChangeActivityRow,
} from '../../../../view/settings/api-automation-settings/change-activity/change-activity.model';

@Injectable({
  providedIn: 'root',
})
export class ChangeActivityService {
  private readonly CHANGE_ACTIVITY_URL = `${this.baseUrl}/api-automation/change-activity`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<IChangeActivity>> {
    return this.http.get<GetManyResponseInterface<IChangeActivity>>(this.CHANGE_ACTIVITY_URL, { params });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<IChangeActivity>> {
    return this.http.get<BaseOneResponseInterface<IChangeActivity>>(`${this.CHANGE_ACTIVITY_URL}/${recordId}`, {
      params,
    });
  }

  public addOne(record: IChangeActivityRow): Observable<BaseOneResponseInterface<IChangeActivity>> {
    return this.http.post<BaseOneResponseInterface<IChangeActivity>>(this.CHANGE_ACTIVITY_URL, record);
  }

  public editOne(recordId: number, record: IChangeActivityRow): Observable<BaseOneResponseInterface<IChangeActivity>> {
    return this.http.patch<BaseOneResponseInterface<IChangeActivity>>(
      `${this.CHANGE_ACTIVITY_URL}/${recordId}`,
      record,
    );
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          changeActivities: recordIds,
        },
      };

      return this.http.delete<BulkResponseDataInterface>(`${this.CHANGE_ACTIVITY_URL}/bulk/delete`, httpOptions);
    }

    return this.http.delete<BulkResponseDataInterface>(`${this.CHANGE_ACTIVITY_URL}/${recordIds[0]}`);
  }
}
